import { useContext } from "react";
import { NotificationContext } from "./NotificationContext";

export const useNotifications = () => {
  const { activeToasts, addToasts, removeToasts } =
    useContext(NotificationContext);
  return {
    activeToasts,
    addToasts,
    removeToasts,
  };
};
